<template>
    <header
        class="md-header layout6"
        :class="[
            {
                mobile: isMobileSize,
                transparent: isMobileSize ? realTransparent && !sideMenuShow : realTransparent,
                hide: hide
            },
            pageClass
        ]"
        :style="adaptiveLogoStyle"
        v-show="showHeader"
    >
        <div
            ref="nav"
            class="header-container"
            role="navigation"
            :style="mainText"
            :class="{ nosticky: isDetail || (!sticky && !isOverlap) }"
        >
            <div class="header-bg" :style="{ background: bgColor }"></div>

            <div class="line-wrap">
            </div>
            <ul v-if="isMobileSize && user" class="head-account head-account-top">
                <li class="menu-item has-child">
                    <a
                        class="menu-user"
                        @click="hideMenu"
                        href="/profile"
                        rel="noopener noreferrer"
                    >
                        <span
                            class="menu-user-initial"
                            :style="{ background: userBackgroundColor }"
                        >{{ initialFirstName }}</span>
                    </a>
                </li>
            </ul>

            <!-- logo start -->
            <div class="logo-menu" :class="{ 'has-sub': hasTwoLogo }">
                <a
                    class="logo"
                    :href="link"
                    rel="noopener noreferrer"
                    role="button"
                    tabindex="0"
                >
                    <site-img
                        :src="logo || null"
                        :style="{ height: size / 100 + 'em' }"
                        :size="100"
                        dir="height"
                        @load="sizeChange(), mobileImgFontSizeRecalc()"
                        :alt="altText || defaultLogoAlt"
                    />
                </a>
                <a
                    v-if="subLogo"
                    class="logo subLogo"
                    style="margin-left: 0"
                    :href="subLogoLink"
                    rel="noopener noreferrer"
                    role="button"
                    tabindex="0"
                >
                    <site-img
                        :src="subLogo || null"
                        :style="{ height: subLogoSize / 100 + 'em' }"
                        :size="100"
                        dir="height"
                        @load="sizeChange(), mobileImgFontSizeRecalc()"
                        :alt="subAltText || defaultSublogoAlt"
                    />
                </a>
            </div>
            <!-- logo end -->

            <div
                v-show="isMobileSize"
                class="menu-icon"
                :class="{ sideMenuShow: sideMenuShow }"
                @click="showMenu(true)"
            >
                <div class="menu-icon-inner">
                    <span class="menu-bar top d-block"></span>
                    <span class="menu-bar middle d-block"></span>
                    <span class="menu-bar bottom d-block"></span>
                </div>
            </div>
                
            <div v-if="!isMobileSize" class="line-gap"></div>

            <div class="nav-container" :class="{ show: sideMenuShow }">
                <!-- nav options ( Webpage navigation ) start -->
                <ul class="head-menu">
                    <menu-item
                        v-for="(menu, index) in outMoreMenus"
                        :key="menu.name + index"
                        :menu="menu"
                        :showMenuArrow="isMobileSize"
                        :arrowIcon="
                            isMobileSize
                                ? 'icon-arrow_08_down'
                                : 'icon-fashion-down'
                        "
                    />

                    <li
                        class="menu-item more"
                        :class="{ 'has-child': moreShow }"
                        @mouseenter="calcMoreStyle"
                    >
                        <a
                            class="iconfont icon-more"
                            style="font-size: 1.33em"
                            role="button"
                            tabindex="0"
                            :aria-label="'More'"
                            rel="noopener noreferrer"
                        ></a>
                        <div class="submenu-container">
                            <div class="wrapper" ref="wrapper">
                                <ol
                                    :style="moreStyle"
                                    class="submenu hidden-scrollbar"
                                >
                                    <menu-item
                                        v-for="(menu, index) in moreMenus"
                                        :key="menu.name + index"
                                        :menu="menu"
                                        :moreItemIndex="index"
                                        isMore
                                        :showMenuArrow="isMobileSize"
                                        :arrowIcon="
                                            isMobileSize
                                                ? 'icon-arrow_08_down'
                                                : 'icon-fashion-down'
                                        "
                                    />
                                </ol>
                            </div>
                        </div>
                    </li>

                    <template v-if="isMobileSize">
                        <li
                            class="menu-item"
                            v-if="showTranslatePlugin"
                            @click="showLangMenu"
                        >
                            <div class="menu-language">
                                <div class="item-name">
                                    <i class="iconfont icon-website3"></i>
                                    {{ $t('md-header.language') }}
                                </div>
                                <div class="item-label">
                                    <site-img
                                        v-if="currentLanguageItem.img"
                                        :src="currentLanguageItem.img"
                                    />
                                    <span
                                        v-else
                                        v-html="currentLanguageItem.label"
                                    ></span>
                                    <i class="iconfont icon-next-big"></i>
                                </div>
                            </div>
                        </li>
                        <li
                            class="menu-item"
                            v-if="showCurrency"
                            @click="showCurrencyMenu"
                        >
                            <div class="menu-currency">
                                <div class="item-name">
                                    <i class="iconfont icon-currency"></i>
                                    {{ $t('md-header.currency') }}
                                </div>
                                <div class="item-label">
                                    {{ currentCurrencyLabel }}
                                    <i class="iconfont icon-next-big"></i>
                                </div>
                            </div>
                        </li>
                        <closely-app-download downloadTheme="black" />
                    </template>
                </ul>
                <!-- nav options ( Webpage navigation ) end -->

                <div v-if="!isMobileSize" class="line-gap"></div>

                <!-- google translate start -->
                <template v-if="!isMobileSize">
                    <ul
                        v-if="showTranslatePlugin"
                        class="head-language-pc language"
                    >
                        <menu-item
                            :menu="translateMenu"
                            class="item-language language"
                        >
                            <template #first>
                                <span
                                    v-html="currentLanguageItem.label"
                                ></span>
                                <i class="iconfont icon-arrow_08_down"></i>
                            </template>
                            <template #second="slotProps">
                                <span
                                    @click="selectLanguage(slotProps.row)"
                                    class="lang-list-item"
                                >
                                    <div class="lang-item-left">
                                        <site-img
                                            class="lang-img"
                                            v-if="slotProps.row.img"
                                            :src="slotProps.row.img"
                                        />
                                        <span class="lang-text">{{
                                            slotProps.row.label
                                        }}</span>
                                    </div>
                                    <em
                                        v-show="
                                            currentLanguage ==
                                                slotProps.row.name
                                        "
                                        class="iconfont icon-checked-light"
                                    ></em>
                                </span>
                            </template>
                        </menu-item>
                    </ul>
                    <ul
                        v-if="showCurrency"
                        class="head-language-pc currency"
                    >
                        <menu-item
                            :menu="curencyMenu"
                            class="item-language currency"
                        >
                            <template #first>
                                <span>{{ currentCurrencyLabel }}</span>
                                <i class="iconfont icon-arrow_08_down"></i>
                            </template>
                            <template #second="slotProps">
                                <span
                                    @click="selectCurrency(slotProps.row)"
                                    class="lang-list-item"
                                >
                                    <span
                                        class="lang-text"
                                    >{{ slotProps.row.abbr }}({{
                                        slotProps.row.symbol
                                    }})-{{ slotProps.row.name }}</span>
                                    <em
                                        v-show="
                                            currentCurrency ==
                                                slotProps.row.abbr
                                        "
                                        class="iconfont icon-checked-light"
                                    ></em>
                                </span>
                            </template>
                        </menu-item>
                    </ul>
                </template>
                <!-- google translate end -->

                <!--  User Info  start -->
                <ul class="head-account" :class="{ 'has-login': user }">
                    <!--  Has logged   Display user related information  start -->
                    <li v-if="user" class="menu-item has-child">
                        <a
                            class="menu-user"
                            @click="hideMenu"
                            href="/profile"
                            rel="noopener noreferrer"
                        >
                            <span
                                class="menu-user-initial"
                                :style="{ background: userBackgroundColor }"
                            >{{ initialFirstName }}</span>
                            <span v-if="isMobileSize" class="first-name">
                                {{ user.firstName }}
                            </span>
                        </a>
                        <div class="wrapper">
                            <ol class="submenu">
                                <li class="menu-item first-name">
                                    {{ user.firstName }}
                                </li>
                                <li class="menu-item">
                                    <a
                                        href="/profile?type=MyHomes"
                                        rel="noopener noreferrer"
                                    >{{ $t('md-header.myHomes') }}</a>
                                </li>
                                <li class="menu-item">
                                    <a
                                        href="/profile?type=MyTour"
                                        rel="noopener noreferrer"
                                    >{{ $t('md-header.myTour') }}</a>
                                </li>
                                <li class="menu-item">
                                    <a
                                        href="/profile?type=Favorites"
                                        rel="noopener noreferrer"
                                    >{{
                                        $t('md-header.myFavorites')
                                    }}</a>
                                </li>
                                <li class="menu-item">
                                    <a
                                        href="/profile?type=Searches"
                                        rel="noopener noreferrer"
                                    >{{ $t('md-header.mySearches') }}</a>
                                </li>
                                <li class="menu-item">
                                    <a
                                        href="/profile?type=Account"
                                        rel="noopener noreferrer"
                                    >{{
                                        $t('md-header.accountSettings')
                                    }}</a>
                                </li>
                                <li v-if="user.isOwner" class="menu-item">
                                    <a
                                        href="/admin/home"
                                        rel="noopener noreferrer"
                                    >{{ $t('md-header.chimeCrm') }}</a>
                                </li>
                                <closely-app-download
                                    useModule="md-header"
                                    class="parent-of-closely"
                                />
                                <li class="menu-item logout">
                                    <a
                                        @click.prevent="logout"
                                        rel="noopener noreferrer"
                                    >{{ $t('md-header.signOut') }}</a>
                                </li>
                            </ol>
                        </div>
                        <span
                            v-show="isMobileSize"
                            class="logout"
                            @click="logout"
                        >
                            {{ $t('md-header.signOut') }}
                        </span>
                    </li>
                    <!--  Has logged   Display user related information  end -->

                    <!--  not logged in   Show Login Register  start -->
                    <template v-else>
                        <li
                            class="menu-item item-regist"
                            role="button"
                            tabindex="0"
                            @click="register"
                        >
                            {{ $t('md-header.register') }}
                        </li>
                        <li class="item-line" v-if="!isMobileSize">/</li>
                        <li
                            class="menu-item item-login"
                            role="button"
                            tabindex="0"
                            @click="signIn"
                        >
                            {{ $t('md-header.signIn') }}
                        </li>
                    </template>
                    <!--  not logged in   Show Login Register  end -->
                </ul>
                <!--  User Info  end -->
            </div>

            <!-- mobile language nav start -->
            <div
                class="nav-container language"
                :style="mainText"
                v-if="
                    isMobileSize &&
                        showTranslatePlugin &&
                        showMobileLangMenu
                "
                :class="{ show: showMobileLangMenu }"
            >
                <ul class="head-language-mobile">
                    <menu-item
                        class="item-language language"
                        v-for="lang in translateMenu.items"
                        mainMenuClass="capitalize"
                        :key="lang.name"
                        :menu="{}"
                        :class="{ active: currentLanguage === lang.name }"
                    >
                        <template #first>
                            <span
                                class="lang-list-item"
                                @click="selectLanguage(lang)"
                            >
                                <site-img
                                    v-if="lang.img"
                                    class="lang-img"
                                    :src="lang?.img || null"
                                    :size="16"
                                    dir="height"
                                    :alt="lang?.label"
                                />
                                <span>{{ lang.label }}</span>
                            </span>
                        </template>
                    </menu-item>
                </ul>
            </div>
            <!-- mobile language nav end -->
            <!-- mobile currency start-->
            <div
                class="nav-container language"
                :style="mainText"
                v-if="
                    isMobileSize && showCurrency && showMobileCurrencyMenu
                "
                :class="{ show: showMobileCurrencyMenu }"
            >
                <ul class="head-language-mobile">
                    <menu-item
                        class="item-language currency"
                        v-for="currency in curencyMenu.items"
                        mainMenuClass="capitalize"
                        :key="currency.abbr"
                        :menu="{}"
                        :class="{
                            active: currentCurrency === currency.abbr
                        }"
                    >
                        <template #first>
                            <span
                                class="lang-list-item"
                                @click="selectCurrency(currency)"
                            >
                                <span>{{ currency.abbr }}({{
                                    currency.symbol
                                }})-{{ currency.name }}</span>
                            </span>
                        </template>
                    </menu-item>
                </ul>
            </div>
            <!-- mobile currency end-->
            

            <div
                class="nav-mask"
                @click="closeAllMenu"
                @touchmove.self.prevent
            ></div>
        </div>
        <div v-if="!isOverlap" class="header-placeholder">
            <div
                :style="{ height: placeHolderHeight, 'min-height': minHeight }"
            ></div>
        </div>
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </header>
</template>

<script>
import Common from '../index';
import scroll from '../scroll';
import util from '@/common/util';
export default {
    mixins: [Common, scroll],
    data: function() {
        return {
            navTop: true,
            useHide: true,
            // showTranslatePlugin: true,
            // showCurrency: true,
            // showMobileLangMenu: true,
            // showMobileCurrencyMenu: true,
            // sideMenuShow: true,
            // languageMenus: [
            //     {
            //         name: 'en',
            //         label: 'ENGLISH',
            //         img: 'https://cdn.chime.me/image/fs/sitebuild/site-cms/translate/en.png'
            //     },
            //     {
            //         name: 'zh-CN',
            //         label: 'CHINESE',
            //         img: 'https://cdn.chime.me/image/fs/sitebuild/site-cms/translate/zh-CN.png'
            //     },
            //     {
            //         name: 'fr',
            //         label: 'FRENCH',
            //         img: 'https://cdn.chime.me/image/fs/sitebuild/site-cms/translate/fr.png'
            //     },
            //     {
            //         name: 'ja',
            //         label: 'JAPANESE',
            //         img: 'https://cdn.chime.me/image/fs/sitebuild/site-cms/translate/ja.png'
            //     },
            //     {
            //         name: 'es',
            //         label: 'SPANISH',
            //         img: 'https://cdn.chime.me/image/fs/sitebuild/site-cms/translate/es.png'
            //     }
            // ],
            // currencyList: [
            //     { id: 10000, abbr: 'USD', symbol: '$', name: 'US Dollar' }
            // ]
        };
    },
    methods: {
        beforePageScroll() {
            return this.sideMenuShow;
        },
        showMenu() {
            this.sideMenuShow = !this.sideMenuShow;
            if (!this.sideMenuShow) {
                this.showMobileLangMenu = false;
                this.showMobileCurrencyMenu = false;
            }
        },
        showLangMenu() {
            this.showMobileLangMenu = false;
            this.showMobileCurrencyMenu = false;
            this.$nextTick(() => {
                this.showMobileLangMenu = true;
            });
        },
        showCurrencyMenu() {
            this.showMobileLangMenu = false;
            this.showMobileCurrencyMenu = false;
            this.$nextTick(() => {
                this.showMobileCurrencyMenu = true;
            });
        }
    },
    computed: {
        minHeight() {
            if (this.isMobileSize || util.isSSRServer) {
                return '30px';
            }
            if (!this.mainMenuText?.fontSize) {
                return '30px';
            }
            let fontsize = this.mainMenuText.fontSize.slice(0, -2);
            let menuHeight = +fontsize + 30;  // 30px is the top and bottom padding value of the menu
            let logoHeight = +this.overlapSize * 40 + 40;  // 40px is the height of the logo, 40px is the top and bottom margin value of the logo
            return Math.min(menuHeight, logoHeight) + 'px';  
        },
        placeHolderHeight() {
            if (this.isMobileSize) {
                let mobileFontSize = this.mobileLogoFont?.current || 24;
                return this.overlapSize * mobileFontSize + 36 + 'px';  // 24px is the font size of the placeholder,36px is the top and bottom margin value of the logo
            }
            return this.overlapSize * 40 + 60 + 'px';  // 40px is the height of the logo, 40px is the top and bottom margin value of the logo
        }
    }
};
</script>
<style lang="scss">
@import './index.scss';
</style>
